import React from "react";
import { Card, Row, Col, Statistic } from "antd";
import {UserOutlined, FolderOpenOutlined } from "@ant-design/icons";
import {Diversity3Sharp, DonutLargeSharp} from "@mui/icons-material";
import GraphicStat from "../../../Components/GraphicStat";

const SuperUserStats = ({ userList, portfolioList }) => {
  return (
    <Row gutter={16}>
      <Col span={8}>
          <GraphicStat
            imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/adobe-stock-free/abstract-blue-gradient-with-diagnol-stripes.jpeg'}
            title="Total Users"
            value={userList.length}
            icon={<Diversity3Sharp style={{ fontSize: '64px', color: '#CED9E1' }} />}
          />
      </Col>
      <Col span={8}>
          <GraphicStat
            imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/adobe-stock-free/modern-element-circle-background.jpeg'}
            title="Total Portfolios"
            value={portfolioList.length}
            overlay={'rgba(0, 0, 0, 0.5)'}
            icon={<DonutLargeSharp style={{ fontSize: '64px', color: '#CED9E1' }} />}
          />
      </Col>
      {/* Add more statistics cards as needed */}
    </Row>
  );
};

export default SuperUserStats;